import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  showAvisoSenhaBoleto: true,
};

export default rules;
